import { InfoCircle } from '@shared/icons';
import { IconWithTooltip } from '../IconWithTooltip/IconWithTooltip';

function SelectedItems({ totalItems, currentItems }: { totalItems: number; currentItems: number }) {
  return currentItems > 0 ? (
    <>
      <span className="text-ui-900 paragraph-explanatory-strong pl-2 pt-0.5 pr-0.5">{currentItems}</span>
      <span className="text-ui-900/40 paragraph-explanatory-strong pt-0.5 opacity-40">/{totalItems}</span>
    </>
  ) : (
    <span className="text-ui-900 paragraph-explanatory-strong pl-2 pt-0.5">All</span>
  );
}
type FilterSectionBaseProps = {
  title: string;
  tooltipContent?: string;
};

type FilterSectionWithoutSelectedItems = FilterSectionBaseProps & {
  totalItems?: never;
  currentItems?: never;
};

type FilterSectionWithSelectedItems = FilterSectionBaseProps & {
  totalItems: number;
  currentItems: number;
};

type FilterSectionTitleProps = FilterSectionWithoutSelectedItems | FilterSectionWithSelectedItems;
function FilterSectionTitle({ title, tooltipContent, totalItems, currentItems, ...props }: FilterSectionTitleProps) {
  return (
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-row items-center">
        <span className="paragraph-strong">{title}</span>
        {!!totalItems && <SelectedItems totalItems={totalItems} currentItems={currentItems} />}
      </div>
      {tooltipContent && (
        <IconWithTooltip tooltipContent={tooltipContent} {...props}>
          <InfoCircle size="small" />
        </IconWithTooltip>
      )}
    </div>
  );
}

export { FilterSectionTitle };
